import { StyleSheet, Text, View } from "react-native";
import CountryFlag from "react-native-country-flag";
import { useFonts } from 'expo-font';

import * as Colors from '../styles/colors'
import * as Fonts from '../styles/typography'

export default function LicensePlate({ plate }) {
    let isMercosul = true

    if(plate.toString().length > 5){
        isMercosul = isNaN(plate[5])
    }

    const [fontsLoaded] = useFonts({
        'FE-Font': require('../../assets/fonts/FE-FONT.ttf'),
    });

    if (!fontsLoaded) {
        return null;
    }

    if (isMercosul) {
        return <View style={styles.plateViewMercosul}>
            <View style={styles.plateTopViewMercosul}>
                <Text style={styles.plateCountryTopView}>{"BRASIL"}</Text>
                <CountryFlag isoCode="br" size={15} style={styles.countryFlag} />
            </View>
            {/* <Text style={styles.plateCountry}>{"BR"}</Text> */}
            <Text style={[styles.plateText,{color: plate ? Colors.BLACK : Colors.GRAY_MEDIUM}]}>{plate ? plate : "AAA-1A11"}</Text>
        </View>
    } else {
        return <View style={styles.plateView}>
            <View style={styles.plateTopView}>
               <View style={styles.plateTopSubView}>
                    <Text style={styles.plateTopSubViewText}>{"BRASIL"}</Text>
               </View>
            </View>
            <Text style={styles.plateText}>{plate ? plate : "AAA-1111"}</Text>
        </View>
    }
}

const styles = StyleSheet.create({
    plateView: {
        backgroundColor: Colors.LICENSE_PLATE,
        borderRadius: 8,
        borderWidth: 4,
        marginTop: 8,
    },
    plateViewMercosul: {
        backgroundColor: Colors.WHITE,
        borderRadius: 8,
        borderWidth: 4,
        marginTop: 8,
        // height: 100, 
    },
    plateText: {
        fontWeight: "bold",
        alignSelf: "center",
        fontSize: 52,
        letterSpacing: 3,
        fontFamily: "FE-Font",
        // marginVertical: 12
    },
    plateCountry: {
        position: "absolute",
        bottom: 0,
        left: 5,
    },
    plateTopView: {
        margin: 4,
        alignItems: "center",
        justifyContent: "center",
    },
    plateTopSubView: {
        borderWidth: 2,
        borderRadius: 8,
        justifyContent: "center",
        alignItems: "center",
         width: "90%",
    },
    plateTopSubViewText: {
        fontWeight: "bold",
        fontSize: Fonts.FONT_SIZE_12,
    },
    plateTopViewMercosul: {
        backgroundColor: "#00339B",
        padding: 4,
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "row",
        borderTopStartRadius: 4,
        borderTopEndRadius: 4
    },
    plateCountryTopView: {
        color: Colors.WHITE,
        fontWeight: "bold",
        fontSize: 16,
        letterSpacing: 2,
        fontFamily: 'FE-Font',
    },
    countryFlag: {
        position: "absolute",
        right: 5,
        fontFamily: 'FE-Font',
        borderWidth: 1,
        borderColor: Colors.WHITE,
        borderRadius: 2
    }
})